module.exports = {
	product: [
		{ key: 'status', value: 'Status' },
		{
			key: 'product_name',
			value: 'Product Name',
		},
		{ key: 'product_code', value: 'Product Code' },
	],
	vendor: [
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'vendor_display_name', value: 'Vendor Display Name' },
		{ key: 'email', value: 'Email' },
		{ key: 'phone_mobile', value: 'Phone Number' },
		{ key: 'status', value: 'Status' },
	],
	purchase_order: [
		{ key: 'status', value: 'Status' },
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'purchase_order_number', value: 'Puchase Order Number' },
	],

	purchase_receive: [
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'status', value: 'Status' },
		{ key: 'purchase_receive_number', value: 'Purchase Receive Number' },
		{ key: 'purchase_order_number', value: 'Purchase Order Number' },
	],
	purchase_bill: [
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'status', value: 'Status' },
		{ key: 'bill_number', value: 'Purchase Bill Number' },
		{ key: 'purchase_order_number', value: 'Purchase Order Number' },
		{ key: 'purchase_receive_number', value: 'Purchase Receive Number' },
	],
	payment_made: [
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'payment_mode', value: 'Payment Mode' },
		{ key: 'payment_number', value: 'Payment Made Number' },
		{ key: 'payment_amount', value: 'Payment Made Amount' },
	],
	credit_note: [
		{
			key: 'vendor_name',
			value: 'Vendor Name',
		},
		{ key: 'status', value: 'Status' },
		{ key: 'credit_note_type', value: 'Credit Note Type' },
		{ key: 'credit_note_number', value: 'Credit Note Number' },
		{ key: 'credit_note_amount', value: 'Credit Note Amount' },
	],
	customers: [
		{
			key: 'name',
			value: 'Customer Name',
		},
		{ key: 'mobile', value: 'Mobile' },
		{ key: 'email', value: 'email' },
		{ key: 'status', value: 'status' },
	],
	doctors: [
		{
			key: 'name',
			value: 'Doctor Name',
		},
		{ key: 'status', value: 'Status' },
		{ key: 'business_name', value: 'Business Name' },
		{ key: 'mobile', value: 'Mobile' },
		{ key: 'email', value: 'email' },
		{ key: 'registration_number', value: 'Registration Number' },
	],

	invoices: [
		{ key: 'status', value: 'Status' },
		{ key: 'invoice_number', value: 'Invoice Number' },
		{ key: 'doctor_name', value: 'Doctor Name' },
		{ key: 'customer_name', value: 'Customer Name' },
		{ key: 'sales_order', value: 'Sales Order' },
	],
	payments_received: [
		{ key: 'payment_receive_number', value: 'Payment #' },
		{ key: 'customer_name', value: 'Customer Name' },
		{ key: 'payment_mode', value: 'Payment Mode' },
	],
	sales_return: [
		{ key: 'status', value: 'Status' },
		{ key: 'return_number', value: 'Sales Return Number' },
		{ key: 'customer', value: 'Customer Name' },
		{ key: 'payment_mode', value: 'Payment Mode' },
	],
	sales_credit_note: [
		{ key: 'status', value: 'Status' },
		{ key: 'credit_note_number', value: 'Credit Note Number' },
		{ key: 'credit_note_type', value: 'Credit Note Type' },
		{ key: 'customer_name', value: 'Customer Name' },
	],
};
